import React from 'react'
import { Empty } from 'antd'
import emptyImage from '../../assets/images/animations/nodata.svg'

export default function NoData({ message }) {
  return (
    <div
      className="mt-5"
      style={{
        borderRadius: "12px",
        background: "#ffffff",
        padding: "1rem",
      }}
    >
      <Empty
        image={emptyImage}
        imageStyle={{
          maxWidth: "50%",  
          margin: "auto", // 👉 make responsive
          height: "auto",     // 👉 auto height
          objectFit: "contain",
        }}
        description={<span>{message}</span>}
      />
    </div>
  );
}
